import {
  keyifyParamsForFiltersRequest,
} from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersSelectors';

import {
  updateFilterById,
} from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersActions';


export function toggleCheckboxFilter(filter) {
  return (dispatch, getState) => {
    const state = getState();
    const key = keyifyParamsForFiltersRequest(state);
    const id = filter.get('id');
    const selected = filter.get('selected');

    const action = updateFilterById(
      key,
      id,
      {
        selected: !selected,
      }
    );

    dispatch(action);
  };
}
